// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chat-change-receipts {
  align-self: flex-start;
  width: min(85%, 560px);
  min-width: 0;
}

.chat-change-receipt-list {
  display: grid;
  gap: 6px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.chat-change-receipt-list li {
  min-width: 0;
  margin: 0;
}

.chat-change-receipt {
  display: flex;
  align-items: center;
  min-width: 0;
  min-height: 56px;
  box-sizing: border-box;
  padding: 7px 11px 7px 12px;
  border: 1px solid var(--border-color);
  border-radius: var(--radius-sm);
  background: var(--card-background);
  color: var(--text-color);
  text-decoration: none;
}

.chat-change-receipt:hover {
  border-color: var(--border-strong);
  background: var(--card-hover);
}

.chat-change-receipt:focus-visible,
.chat-change-receipts-toggle:focus-visible {
  outline: 2px solid var(--link-color);
  outline-offset: 2px;
}

.chat-change-receipt-copy {
  display: flex;
  flex: 1;
  flex-direction: column;
  min-width: 0;
  gap: 2px;
}

.chat-change-receipt-eyebrow {
  overflow: hidden;
  color: var(--secondary-text-color);
  font-size: 0.68rem;
  font-weight: 600;
  line-height: 1.15;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.chat-change-receipt-title {
  overflow: hidden;
  font-size: 0.9rem;
  font-weight: 600;
  line-height: 1.25;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.chat-change-receipt-chevron {
  flex: none;
  margin-left: 12px;
  color: var(--secondary-text-color);
  font-size: 0.68rem;
}

.chat-change-receipts-toggle {
  margin-top: 5px;
  padding: 2px 0;
  border: 0;
  border-radius: 0;
  background: transparent;
  color: var(--link-color);
  font: inherit;
  font-size: 0.78rem;
  font-weight: 600;
  text-decoration: underline;
  text-underline-offset: 2px;
  cursor: pointer;
}

button.chat-change-receipts-toggle:not(:disabled):hover {
  background: transparent;
  color: var(--link-color);
}

@media (max-width: 600px) {
  .chat-change-receipts {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/chat/ChatChangeReceipts.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,0BAA0B;EAC1B,qCAAqC;EACrC,+BAA+B;EAC/B,kCAAkC;EAClC,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,kCAAkC;EAClC,6BAA6B;AAC/B;;AAEA;;EAEE,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,OAAO;EACP,sBAAsB;EACtB,YAAY;EACZ,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;EACT,gBAAgB;EAChB,uBAAuB;EACvB,wBAAwB;EACxB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE;IACE,WAAW;EACb;AACF","sourcesContent":[".chat-change-receipts {\n  align-self: flex-start;\n  width: min(85%, 560px);\n  min-width: 0;\n}\n\n.chat-change-receipt-list {\n  display: grid;\n  gap: 6px;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n.chat-change-receipt-list li {\n  min-width: 0;\n  margin: 0;\n}\n\n.chat-change-receipt {\n  display: flex;\n  align-items: center;\n  min-width: 0;\n  min-height: 56px;\n  box-sizing: border-box;\n  padding: 7px 11px 7px 12px;\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius-sm);\n  background: var(--card-background);\n  color: var(--text-color);\n  text-decoration: none;\n}\n\n.chat-change-receipt:hover {\n  border-color: var(--border-strong);\n  background: var(--card-hover);\n}\n\n.chat-change-receipt:focus-visible,\n.chat-change-receipts-toggle:focus-visible {\n  outline: 2px solid var(--link-color);\n  outline-offset: 2px;\n}\n\n.chat-change-receipt-copy {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  min-width: 0;\n  gap: 2px;\n}\n\n.chat-change-receipt-eyebrow {\n  overflow: hidden;\n  color: var(--secondary-text-color);\n  font-size: 0.68rem;\n  font-weight: 600;\n  line-height: 1.15;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.chat-change-receipt-title {\n  overflow: hidden;\n  font-size: 0.9rem;\n  font-weight: 600;\n  line-height: 1.25;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.chat-change-receipt-chevron {\n  flex: none;\n  margin-left: 12px;\n  color: var(--secondary-text-color);\n  font-size: 0.68rem;\n}\n\n.chat-change-receipts-toggle {\n  margin-top: 5px;\n  padding: 2px 0;\n  border: 0;\n  border-radius: 0;\n  background: transparent;\n  color: var(--link-color);\n  font: inherit;\n  font-size: 0.78rem;\n  font-weight: 600;\n  text-decoration: underline;\n  text-underline-offset: 2px;\n  cursor: pointer;\n}\n\nbutton.chat-change-receipts-toggle:not(:disabled):hover {\n  background: transparent;\n  color: var(--link-color);\n}\n\n@media (max-width: 600px) {\n  .chat-change-receipts {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
